import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import { handleLogout } from "containers/Login/reducer";
import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

class LoginContainer extends React.PureComponent {
  componentDidMount() {
    return this.props.handleLogout();
  }
  render() {
    return (
      <div style={{ height: "calc(100vh - 90px)", textAlign: "center" }}>
        <LoadingIndicator />
        <h3>Logging Out</h3>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  handleLogout: () => dispatch(handleLogout())
});

const mapStateToProps = (state) => ({});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(LoginContainer);
